<template>
    <div class="w-full h-full flex items-center justify-between px-4">
        <LayoutLogo />
        <div class="flex items-center gap-1">
            <UPopover>
                <UTooltip text="Aparência">
                    <UButton icon="i-solar-palette-linear" variant="ghost" color="neutral" />
                </UTooltip>
                <template #content>
                    <div class="p-4">
                        <SettingsColor />
                    </div>
                </template>
            </UPopover>
            <UTooltip text="Menu">
                <USlideover side="left">
                    <UButton icon="i-heroicons-bars-3-20-solid" variant="ghost" color="neutral" />
                    <template #body>
                        <LayoutMenu />
                    </template>
                </USlideover>
            </UTooltip>
        </div>
    </div>
</template>
<script setup>
</script>
